import React from 'react';
import { useReveal } from '../hooks/useReveal';

const SectionHeader = ({ title, subtitle, id }: { title: string; subtitle?: string; id?: string }) => {
	const ref = useReveal();
	return (
		<div id={id} className="max-w-6xl mx-auto px-6 pt-28 pb-4">
			<div ref={ref} className="reveal">
				<p className="text-accent text-xs font-bold uppercase tracking-[0.2em] mb-2">{subtitle}</p>
				<h2 className="font-display font-bold text-3xl md:text-4xl text-white">{title}</h2>
				<div className="mt-4 flex items-center gap-3">
					<div className="h-px w-12 bg-gradient-to-r from-accent to-accent-2" />
					<div className="h-px flex-1 bg-slate-800" />
				</div>
			</div>
		</div>
	);
};

export default SectionHeader;
